import { Variant } from './Variant';
import { Category } from './Category';

export type ProductPackagingType = 'box' | 'simple';
export enum ProductPackagingTypeList {
  BOX = 'box',
  SIMPLE = 'simple',
}
export const ProductPackagingDefaultType = 'simple';
export interface Product {
  productId?: string;
  productKey?: string;
  changed?: Date;
  version?: string;
  name?: string;
  slug?: string;
  description?: string;
  categories?: Category[];
  variants: Variant[];
  _url?: string;
  visibilityStatus?: string;
}
